module.exports = __webpack_public_path__ + "static/img/px4.49c03ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/px4.png
// module id = cjmE
// module chunks = 2